<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="90px">
         <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions(true)"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList(true)"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="等级">
              <el-select
                clearable
                v-model="queryParamForm.gradeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in queryGradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row :gutter="10">
           <el-col :span="6">
            <el-form-item label="定价回收商">
              <el-select
                clearable
                v-model="queryParamForm.serviceId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getModelPriceDeductionListSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="addBasePrice">创建</el-button>
          </el-col>
         <el-col :span="3.8">
              <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
              <el-upload
                      style="display:inline"
                      action="aa"
                      :show-file-list="false"
                      :before-upload="importSendInfo">
                <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
           </el-col>
        <el-col :span="3" style="margin-top:10px">
            <a type="primary" @click="getSkuTemplete">导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="serviceName" label="定价回收商">
        </el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="modelNames" label="机型"> </el-table-column>
        <!-- <el-table-column prop="skuNames" label="sku"> </el-table-column> -->
        <!-- <el-table-column prop="gradeName" label="等级"> </el-table-column> -->
        <el-table-column prop="itemNames" label="评估项目"> </el-table-column>
        <el-table-column prop="itemValueNames" label="扣款项"> </el-table-column>
        <el-table-column prop="price" label="扣款金额"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>不启用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不启用</el-button
            >
             <el-button @click="deleteLevelPriceDeduction(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change' ? '编辑机型等级扣款项' : '新建机型等级扣款项'
      "
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editBasePriceForm"
            :model="editBasePriceForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editBasePriceForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="定价回收商" prop="serviceId">
              <el-select
                clearable
                v-model="editBasePriceForm.serviceId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editBasePriceForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions(false)"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                clearable
                v-model="editBasePriceForm.brandId"
                placeholder="请选择"
                @change="getModelList(false)"
              >
                <el-option
                  v-for="item in editBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="机型" prop="modelId">
              <el-select
                clearable
                v-model="editBasePriceForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in editModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="机型" prop="modelScope">
              <el-select
                  clearable
                  v-model="editBasePriceForm.modelScope"
                  placeholder="请选择"
                  @change="getListSkuByModelIds(true)"
              >
                <el-option
                    v-for="item in modelScopeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label=""
              prop="modelIdList"
              class="topselect w130 ml15"
              v-show="editBasePriceForm.modelScope===1"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="modelIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSelectValue(modelIdList)"
                  >
                    <el-option
                      v-for="item in editModelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
               <el-col>
                  <el-checkbox v-model="allSelectFlag" @change="selectModel">全部机型</el-checkbox>
               </el-col>
             </el-row>
            </el-form-item>

            <el-form-item label="SKU" prop="skuIdList">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="skuIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSkuSelectValue(skuIdList)"
                  >
                    <el-option
                      v-for="item in vaildSkuList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>

            <el-form-item label="适用商户" prop="merchantScope">
              <el-select
                  clearable
                  v-model="editBasePriceForm.merchantScope"
                  placeholder="请选择"

              >
                <el-option
                    v-for="item in merchantScopeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item
              label="商户"
              prop="merchantIdList"
              class="topselect w130 ml15"
              v-show="editBasePriceForm.merchantScope===1"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="merchantIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSelectMerchantValue(merchantIdList)"
                  >
                    <el-option
                      v-for="item in editMerchantList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
               <el-col>
                  <el-checkbox v-model="allSelectMerchantFlag" @change="selectMerchant">全部商户</el-checkbox>
               </el-col>
             </el-row>
            </el-form-item>

            <el-form-item
              label="等级"
              prop="gradeIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="gradeIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                      @change="getSelectGradeValue(gradeIdList)"
                  >
                    <el-option
                      v-for="item in editGradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
               <el-col>
                  <el-checkbox v-model="allSelectGradeFlag" @change="selectGrade">全部等级</el-checkbox>
               </el-col>
             </el-row>
            </el-form-item>

            <!-- <el-form-item label="等级" prop="gradeId">
              <el-select
                clearable
                v-model="editBasePriceForm.gradeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in editGradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <!-- <el-form-item label="扣款评估项目" prop="itemId">
              <el-select
                clearable
                v-model="editBasePriceForm.itemId"
                placeholder="请选择"
                @change="changeItemValueOptions(editBasePriceForm.itemId, null)"
              >
                <el-option
                  v-for="item in functionConditionValues"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item
              label="扣款评估项目"
              prop="itemIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="itemIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                    @change="getSelectItem(itemIdList)"
                  >
                    <el-option
                      v-for="item in functionConditionValues"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
             </el-row>
            </el-form-item>


            <!-- <el-form-item label="扣款选项" prop="itemValueId">
              <el-select
                clearable
                v-model="editBasePriceForm.itemValueId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in itemValueOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item
              label="扣款选项"
              prop="itemValueIdList"
              class="topselect w130 ml15"
            >
             <el-row>
               <el-col>
                  <el-select
                    clearable
                    style="width:100%"
                    v-model="itemValueIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in itemValueOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
               </el-col>
             </el-row>
            </el-form-item>

            <el-form-item label="扣款金额" prop="price">
                <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="10"> <el-select
                v-model="editBasePriceForm.deduceType"
              >
                <el-option
                  v-for="item in deduceTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select></el-col>
                 <el-col :span="16">
                  <el-input clearable v-model="editBasePriceForm.price"  :placeholder="editBasePriceForm.deduceType==1?'请输入小数':'请输入正数'" ></el-input>
                 </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        categoryId: null,
        modelId: null,
        brandId: null,
        gradeId: null,
        serviceId: null,
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      skuIdList:[],

      modelScopeOptions: [{
        value: 0,
        label: '通用'
      }, {
        value: 1,
        label: '部分机型'
      },],
      merchantScopeOptions: [{
        value: 0,
        label: '通用'
      }, {
        value: 1,
        label: '部分商户'
      },],


      // 新建编辑对话框数据

      isDlg: false,
      editBasePriceForm: {
        id: null,
        value: null,
        price: 0,
        categoryId: null,
        modelScope:null,
        merchantScope:null,
        modelIds: null,
        brandId: null,
        gradeIds: null,
        serviceId: null,
        itemValueIds: null,
        itemIds: null,
        itemIdList: [],
        gradeIdList:[],
        itemValueIdList: [],
        modelIdList: [],
        skuIdList:[],
        merchantIdList: [],
        deduceType: 1
      },

      editorFormRules: {
        modelScope: [
          { required: true, message: "请选择机型适用范围", trigger: "change" }
        ],
        modelIdList: [
          { required: false, message: "请选择机型", trigger: "change" }
        ],
        merchantScope: [
          { required: true, message: "请选择商户适用范围", trigger: "change" }
        ],
        merchantIdList: [
          { required: false, message: "请选择机型", trigger: "change" }
        ],
        skuIdList: [
          { required: false, message: "请选择SKU", trigger: "change" }
        ],
        brandId: [
          { required: true, message: "请选择品牌", trigger: "change" }
          ],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        gradeIdList: [
          { required: true, message: "请选择等级", trigger: "change" }
          ],
        itemIdList: [
          { required: true, message: "请选择选项", trigger: "change" }
        ],
        serviceId: [
          { required: true, message: "请选择回收商", trigger: "change" },
        ],
        price: [
          { required: true, message: "请输入扣款金额", trigger: "change" },
        ],
      },

      dlgType: "change",

      deduceTypeList:[{id:1,name:'比列'},{id:2,name:'固定金额'}],

      // 选择
      loading: false,
      modelIdList: [],
      allSelectFlag:false,

      merchantIdList:[],
      editMerchantList:[],
      allSelectMerchantFlag:false,
      gradeIdList:[],
      allSelectGradeFlag:false,

      queryCategoryOptions: [],
      queryBrandOptions: [],
      queryServiceList: [],
      queryGradeList: [],
      queryModelList: [],

      editGradeList: [],
      editModelList: [],
      editBrandOptions: [],

      itemIdList:[],

      editItemIdList: [],

      itemValueIdList:[],

      editItemValueIdList: [],

      evalProjectList: [],
      evalItemValueList: [],
      //评估项目和值
      functionConditionValues: [],
      itemValueOptions: [],
      fullscreenLoading:false,
      vaildSkuList:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
     deleteLevelPriceDeduction(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deleteLevelPriceDeduction({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getModelPriceDeductionListSearch()
          }
      })
      })
     
    },
      // click事件
    exportExcelData () {
      let self = this
       self.$api
        .modelPriceDeductionListSearch({
          page: self.currentPage,
          size: self.tableTotal,
          categoryId: self.queryParamForm.categoryId || null,
          modelId: self.queryParamForm.modelId || null,
          brandId: self.queryParamForm.brandId || null,
          serviceId: self.queryParamForm.serviceId || null,
          gradeId: self.queryParamForm.gradeId || null,
        })
        .then((res) => {
          var downLoadTableData = res.data.records || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName =["编号","定价回收商","机型","品牌","分类","等级","评估项目","扣款项","扣款金额","状态"];
                const filterVal = ["value", "serviceName", "modelName", "brandName","categoryName","gradeName","itemNames","itemValueNames", "price", "status"];
                const data = downLoadTableData.map(v => filterVal.map(j => {
                  if(j=="status"){
                    return v[j]==1?"启用":"禁用"
                  }
                  return v[j]
                }));
                export_json_to_excel(fieldName, data, "机型等级扣款项"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
     // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.imporModelPriceDeductionTemplete(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getModelPriceDeductionListSearch()
        }
      })
      return false;
    },
    getSkuTemplete(){
      window.open(`/api/hjx/modelPriceDeduction/getModelPriceDeductionTemplete`,"_blank")
    },

    //改变分类，品牌和等级集合发生变化
    changeOtherOptions(isQuery) {
      let self = this;
      if (isQuery) {
        this.$set(this.queryParamForm, "brandId", null);
        this.$set(this.queryParamForm, "gradeId", null);
        this.$set(this.queryParamForm, "modelId", null);
        this.$set(this, "queryModelList", []);
      } else {
        this.$set(this.editBasePriceForm, "brandId", null);
        this.$set(this.editBasePriceForm, "gradeId", null);
        this.$set(this.editBasePriceForm, "modelId", null);
        this.$set(this.editBasePriceForm, "itemId", null);
        this.$set(this.editBasePriceForm, "itemValueId", null);
        this.$set(this.editBasePriceForm, "skuIdList", []);
        this.$set(this, "skuIdList", []);
        this.$set(this, "editModelList", []);
        this.$set(this, "functionConditionValues", []);
        this.$set(this, "itemValueOptions", []);
        this.$set(this, "vaildSkuList", []);
      }
      self.getBrandOptions(isQuery,!isQuery);
      self.getGradeList(isQuery);
      // self.getEavlItemOptions(true, []);
     
    },
       //选择全部机型
    selectModel(val){
        this.modelIdList=[]
        if(val){
          this.editModelList.forEach(item=>{
                this.modelIdList.push(item.id)
          })
        }
        this.editBasePriceForm.modelIdList = this.modelIdList;
    },

    //机型选框当中的选择
    getSelectValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "modelIdList", values);
      self.getListSkuByModelIds(true)
      if(self.modelIdList.length==self.editModelList.length){
        self.allSelectFlag = true
      }else{
        self.allSelectFlag = false
      }
    },

      //机型选框当中的选择
    getSkuSelectValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "skuIdList", values);
    },

    //根据机型获取sku
    getListSkuByModelIds(isEdit){
      let self = this
        if(self.modelIdList!=null&&self.modelIdList.length>0){
            self.$api.getListSkuByModelIds({
            modelIds: self.modelIdList
          }).then((res) => {
                if(isEdit){
                  self.skuIdList=[]
                }
                self.vaildSkuList = res.data;
                self.vaildSkuList.unshift({'id':0,'name':'通用'})
          });
        }else{
          self.skuIdList=[]
          self.vaildSkuList =[]
          self.vaildSkuList.unshift({'id':0,'name':'通用'})
        }
    },
    
    //机型
   async getModelList(isQuery,isChange) {
      let brandId = isQuery
        ? this.queryParamForm.brandId
        : this.editBasePriceForm.brandId;

      this.getEavlItemOptions(true, []);

      isQuery
        ? this.$set(this.queryParamForm, "modelId", null)
        : this.$set(this.editBasePriceForm, "modelId", null);
      if(isChange){
         this.$set(this.editBasePriceForm, "modelIdList", []);
         this.$set(this, "modelIdList", []);
      }
      if (brandId === "") {
        this.$set(this, isQuery ? "queryModelList" : "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            isQuery
              ? (self.queryModelList = res.data.records || [])
              : (self.editModelList = res.data.records || []);
            self.allSelectFlag = false
            if(self.modelIdList!=null&&self.modelIdList.length>0&&self.modelIdList.length==self.editModelList.length){
              self.allSelectFlag = true
            }
          });
      }
    },
    //等级
   async getGradeList(isQuery) {
      let self = this;
      let categoryId = isQuery
        ? this.queryParamForm.categoryId
        : this.editBasePriceForm.categoryId;
      if (categoryId === "") {
        this.$set(this, isQuery ? "queryGradeList" : "editGradeList", []);
      } else {
        this.$api
          .getValidModelGrade({
            categoryId: categoryId,
          })
          .then((res) => {
            isQuery
              ? (self.queryGradeList = res.data || [])
              : (self.editGradeList = res.data || []);
          });
      }
    },
    getSelectGradeValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "gradeIdList", values);
      if(self.gradeIdList.length==self.editGradeList.length){
        self.allSelectGradeFlag = true
      }else{
         self.allSelectGradeFlag = false
      }
    },
    selectGrade(val){
          this.gradeIdList=[]
          if(val){
            this.editGradeList.forEach(item=>{
                  this.gradeIdList.push(item.id)
            })
          }
          this.editBasePriceForm.gradeIdList = this.gradeIdList;
      },
    //选中评估项，更新评估项选项值
    getSelectItem(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "itemIdList", values);
      //console.log(values);

      if (values === "") {
        this.editBasePriceForm.itemValueId = null;
        this.$set(this, "itemValueOptions", []);
        return;
      }
      this.itemValueOptions = [];
      for (
        let index = 0;
        index < this.functionConditionValues.length;
        index++
      ) {
        let item = this.functionConditionValues[index];
        // console.log(item.id);
        // console.log(values.includes(item.id));
        if(values.includes(item.id)){
          this.itemValueOptions = this.itemValueOptions.concat(item.children);
          //this.itemValueOptions.concat(item.children);
          // console.log(this.itemValueOptions);
          //this.$set(this.editBasePriceForm, "itemValueIdList", itemValueId);
          // this.
          // this.$set(this.editBasePriceForm, "itemValueIdList", itemValueId);
        }

      }


      // if(self.gradeIdList.length==self.editGradeList.length){
      //   self.allSelectGradeFlag = true
      // }else{
      //   self.allSelectGradeFlag = false
      // }
    },

    selectItem(val){
          this.itemIdList=[]
          if(val){
            this.editItemIdList.forEach(item=>{
                  this.itemIdList.push(item.id)
            })
          }
          this.editBasePriceForm.itemIdList = this.itemIdList;
      },

    //获取选项值
    getSelectItemValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "itemValueIdList", values);
      // if(self.gradeIdList.length==self.editGradeList.length){
      //   self.allSelectGradeFlag = true
      // }else{
      //   self.allSelectGradeFlag = false
      // }
    },

    //机型
    // getModelList(isQuery) {
    //   let brandId = isQuery
    //     ? this.queryParamForm.brandId
    //     : this.editBasePriceForm.brandId;
    //   isQuery
    //     ? this.$set(this.queryParamForm, "modelId", null)
    //     : this.$set(this.editBasePriceForm, "modelId", null);
    //   if (brandId === "") {
    //     this.$set(this, isQuery ? "queryModelList" : "editModelList", []);
    //     this.$set(this.editBasePriceForm, "modelId", null);
    //     this.$set(this.editBasePriceForm, "itemId", null);
    //     this.$set(this.editBasePriceForm, "itemValueId", null);
    //     this.$set(this, "editModelList", []);
    //     this.$set(this, "functionConditionValues", []);
    //     this.$set(this, "itemValueOptions", []);
    //   } else {
    //     let self = this;
    //     this.getEavlItemOptions(false, null, null);
    //     self.$api
    //       .getClass({
    //         brandId: brandId,
    //         typeKey: "phoneModal",
    //         status: 1,
    //         page: 1,
    //         size: 100000,
    //       })
    //       .then((res) => {
    //         isQuery
    //           ? (self.queryModelList = res.data.records || [])
    //           : (self.editModelList = res.data.records || []);
    //       });
    //   }
    // },
    //等级
    // getGradeList(isQuery) {
    //   let self = this;
    //   let categoryId = isQuery
    //     ? this.queryParamForm.categoryId
    //     : this.editBasePriceForm.categoryId;
    //   if (categoryId === "") {
    //     this.$set(this, isQuery ? "queryGradeList" : "editGradeList", []);
    //   } else {
    //     this.$api
    //       .getValidModelGrade({
    //         categoryId: categoryId,
    //       })
    //       .then((res) => {
    //         isQuery
    //           ? (self.queryGradeList = res.data || [])
    //           : (self.editGradeList = res.data || []);
    //       });
    //   }
    // },
    //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },

 

    //选中评估项，更新评估项选项值
    // changeItemValueOptions(val, itemValueId) {
    //   if (val === "") {
    //     this.editBasePriceForm.itemValueId = null;
    //     this.$set(this, "itemValueOptions", []);
    //     return;
    //   }
    //   for (
    //     let index = 0;
    //     index < this.functionConditionValues.length;
    //     index++
    //   ) {
    //     let item = this.functionConditionValues[index];
    //     if (val === item.id) {
    //       this.itemValueOptions = item.children;
    //       this.$set(this.editBasePriceForm, "itemValueId", itemValueId);
    //       break;
    //     }
    //   }
    // },



    getSelectMerchantValue(values) {
      let self = this;
      self.$set(self.editBasePriceForm, "merchantIdList", values);
      if(self.merchantIdList.length==self.editMerchantList.length){
        self.allSelectMerchantFlag = true
      }else{
         self.allSelectMerchantFlag = false
      }
      
    },
    selectMerchant(val){
      this.merchantIdList=[]
      if(val){
        this.editMerchantList.forEach(item=>{
              this.merchantIdList.push(item.id)
        })
      }
      this.$set(this.editBasePriceForm, "merchantIdList", this.merchantIdList);
    },

    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getModelPriceDeductionListSearch();
    },

    // 获取表格数据
    getModelPriceDeductionListSearch() {
      let self = this;
      self.$api
        .modelPriceDeductionListSearch({
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.queryParamForm.categoryId || null,
          modelId: self.queryParamForm.modelId || null,
          brandId: self.queryParamForm.brandId || null,
          serviceId: self.queryParamForm.serviceId || null,
          gradeId: self.queryParamForm.gradeId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.editBasePriceForm = {};
      
       this.$nextTick(()=>{
          this.$refs['editBasePriceForm'].clearValidate()
      })
      this.$set(this.editBasePriceForm,"deduceType",1)
      this.editGradeList = [];
      this.editModelList = [];
      this.editBrandOptions = [];

      this.modelIdList = []
      this.merchantIdList = []
      this.gradeIdList = []

      this.skuIdList = []
      this.itemIdList = []
      this.editItemIdList = []
      this.itemValueIdList = []
      this.editItemValueIdList = []
      this.vaildSkuList=[]

      this.allSelectFlag = false
      this.allSelectMerchantFlag = false
      this.allSelectGradeFlag = false

      this.isDlg = true;
    },

    // 修改，把对应的值赋值给对应的变量
    editormodel(row) {
      let self = this;
      self.editBasePriceForm = {};
      self.dlgType = "change";
      self.editBasePriceForm = JSON.parse(JSON.stringify(row));

      self.$set(self, "modelIdList", []);
      self.$set(self, "skuIdList", []);
      self.$set(self, "merchantIdList", []);
      self.$set(self, "gradeIdList", []);
      self.$set(self, "itemIdList", []);
      self.$set(self, "itemValueIdList", []);
      self.$set(self.editBasePriceForm, "modelIdList", []);
      self.$set(self.editBasePriceForm, "skuIdList", []);
      self.$set(self.editBasePriceForm, "merchantIdList", []);
      self.$set(self.editBasePriceForm, "gradeIdList", []);
      self.$set(self.editBasePriceForm, "itemIdList", []);
      self.$set(self.editBasePriceForm, "itemValueIdList", []);
      self.vaildSkuList=[]

      const modelIds = self.editBasePriceForm.modelIds;
      if(modelIds != null){
        self.modelIdList = modelIds.split(",");
        self.getListSkuByModelIds(false)
      }else{
        self.getListSkuByModelIds(false)
      }
      const merchantIds = self.editBasePriceForm.merchantIds;
      if(merchantIds != null){
        self.allSelectMerchantFlag = false
        self.merchantIdList = merchantIds.split(",");
      }
      const gradeId = self.editBasePriceForm.gradeIds;
      // const gradeId = "1,2";
      if(gradeId != null){
        self.allSelectGradeFlag = false
        self.gradeIdList = gradeId.split(",");
      }
      //const gradeId = self.editBasePriceForm.gradeId;
      const itemIds = self.editBasePriceForm.itemIds;
      if(itemIds != null){
        self.itemIdList = itemIds.split(",");
        // 使用map()函数和parseInt()将字符串数组转换为整数数组
        self.itemIdList = self.itemIdList.map(str => parseInt(str));
        self.$set(self.editBasePriceForm, "itemIdList", self.itemIdList);
      }

       const skuIds = self.editBasePriceForm.skuIds;
      if(skuIds != null){
        self.skuIdList = skuIds.split(",");
        // 使用map()函数和parseInt()将字符串数组转换为整数数组
        self.skuIdList = self.skuIdList.map(str => parseInt(str));
        self.$set(self.editBasePriceForm, "skuIdList", self.skuIdList);
      }

      const itemValueIds = self.editBasePriceForm.itemValueIds;
      if(itemValueIds != null){
        self.itemValueIdList = itemValueIds.split(",");
      }

      self.getModelList(false,false);
      self.getGradeList(false);

      self.getBrandOptions(false,false);
      //self.getModelList(false);
      //self.getGradeList(false);
      //self.getEavlItemOptions(true, row.itemId, row.itemValueId);
      self.getEavlItemOptions(true, self.itemIdList);

      self.isDlg = false;
      this.$nextTick((e) => {
        // self.$set(self.editBasePriceForm, "brandId", row.brandId);
        // self.$set(self.editBasePriceForm, "gradeId", row.gradeId);
        self.$set(self.editBasePriceForm, "modelId", row.modelId);
        // self.$set(self.editBasePriceForm, "itemId", row.itemId);
        self.isDlg = true;

        self.modelIdList = self.modelIdList.map((i) => parseInt(i, 0));
        self.$set(self.editBasePriceForm, "modelIdList", self.modelIdList);
        if(self.merchantIdList!=null&&self.merchantIdList.length>0){
          self.merchantIdList = self.merchantIdList.map((i) => parseInt(i, 0));
          self.allSelectMerchantFlag = false
          if(self.merchantIdList!=null&&self.merchantIdList.length>0&&self.merchantIdList.length==self.editMerchantList.length){
            self.allSelectMerchantFlag = true
          }
          self.$set(self.editBasePriceForm, "merchantIdList", self.merchantIdList);
        }
        if(self.gradeIdList!=null&&self.gradeIdList.length>0){
          self.gradeIdList = self.gradeIdList.map((i) => parseInt(i, 0));
          self.allSelectGradeFlag = false
          if(self.gradeIdList!=null&&self.gradeIdList.length>0&&self.gradeIdList.length==self.editGradeList.length){
            self.allSelectGradeFlag = true
          }
          self.$set(self.editBasePriceForm, "gradeIdList", self.gradeIdList);
        }
        if(self.itemIdList!=null&&self.itemIdList.length>0){
          self.itemIdList = self.itemIdList.map((i) => parseInt(i, 0));
          self.$set(self.editBasePriceForm, "itemIdList", self.itemIdList);
        }
        if(self.itemValueIdList!=null&&self.itemValueIdList.length>0){
          self.itemValueIdList = self.itemValueIdList.map((i) => parseInt(i, 0));
          self.$set(self.editBasePriceForm, "itemValueIdList", self.itemValueIdList);
        }
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editBasePriceForm"].validate((valid) => {
        if (valid) {
          let params = this.editBasePriceForm;

          
          // params.itemName = this.functionConditionValues.find(
          //   (item) => item.id == params.itemId
          // ).name;

          let itemNameList = [];
          for (let i = 0; i < this.itemIdList.length; i++) {
            const itemId = this.itemIdList[i];
            const item = this.functionConditionValues.find(option => option.id === itemId);
            if (item) {
              itemNameList.push(item.name);
            }
          }

          // params.itemValueName = this.itemValueOptions.find(
          //   (item) => item.id == params.itemValueId
          // ).name;

          let itemValueNameList = [];
          for (let i = 0; i < this.itemValueIdList.length; i++) {
            const itemId = this.itemValueIdList[i];
            const item = this.itemValueOptions.find(option => option.id === itemId);
            if (item) {
              itemValueNameList.push(item.name);
            }
          }

          params.skuIds = this.skuIdList.join(",");

          params.itemIds = this.itemIdList.join(",");
          params.itemNames = itemNameList.join(",");

          params.itemValueIds = this.itemValueIdList.join(",");
          params.itemValueNames = itemValueNameList.join(",");

          if (params.modelScope === 0) {
            params.modelIds = null;
          } else {
            params.modelIds = this.modelIdList.join(",");
          }

          if (params.merchantScope === 0) {
            params.merchantIds = null;
          } else {
            params.merchantIds = this.merchantIdList.join(",");
          }
          params.gradeIds = this.gradeIdList.join(",");

          self.$api.updateModelPriceDeduction(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getModelPriceDeductionListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取评估项目选项和值
    getEavlItemOptions(isEdit, itemIdList) {
      if (this.editBasePriceForm.categoryId === "") {
        return;
      }
      let self = this;
      self.$api
        .getEvaluationOptions({
          categoryId: self.editBasePriceForm.categoryId,
          brandId: self.editBasePriceForm.brandId,
          typeKey:
            "evaluate_condition,evaluate_function,evaluate_value,sku_small_model,sku_network,sku_warranty_duration,sku_body_color,sku_purchase_channel,category",
        })
        .then((res) => {
          if (res.code === 200) {
            self.functionConditionValues = res.data;
            if (isEdit) {
              self.getSelectItem(itemIdList);
              //self.changeItemValueOptions(itemIdList, itemValueId);
            }
          }
        });
    },

    getBrandOptions(isQuery,isChange = false) {
      let categoryId = isQuery
        ? this.queryParamForm.categoryId
        : this.editBasePriceForm.categoryId;
      if(isChange){
         this.$set(this.editBasePriceForm, "modelIdList", []);
         this.$set(this, "modelIdList", []);
      }
      if (categoryId === "") {
        this.$set(this, isQuery ? "queryBrandOptions" : "editBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            isQuery
              ? (self.queryBrandOptions = res.data.records || [])
              : (self.editBrandOptions = res.data.records || []);
          });
      }
    },

    getCategroyOptions() {
      let self = this;
      this.$api
        .getClass({
          typeKey: "category",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.queryCategoryOptions = res.data.records || [];
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      this.$api.updateModelPriceDeduction(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getModelPriceDeductionListSearch();
        }
      });
    },


        //有效商户
    getValidMerchant(){
       let self = this;
      this.$api.getValidMerchant().then((res) => {
        self.editMerchantList = res.data
      })
    }
  },
  created() {},
  mounted() {
    let self = this;
    self.getModelPriceDeductionListSearch();
    self.getCategroyOptions();
    self.getServiceList();
    self.getValidMerchant();
  },
};
</script>
<style lang="less" scoped></style>
